<script setup>
const props = defineProps(["product"]);
</script>

<template>
	<div
		class="group relative isolate flex aspect-square items-end overflow-hidden rounded-lg bg-white text-black"
	>
		<div class="flex w-full items-center justify-between p-12 md:p-24">
			<router-link
				:to="{
					name: 'product',
					params: { slug: product.slug },
				}"
				class="sm:h8 h9 font-primary-condensed box-link"
			>
				<h3>{{ product.title }}</h3>
			</router-link>
			<p class="sm:h8 h9 font-primary">{{ product.price }}</p>
		</div>
		<img
			class="absolute inset-0 -z-1 size-full object-cover transition-transform duration-300 group-hover:scale-102"
			:src="product.image"
		/>
	</div>
</template>
